export default __webpack_public_path__ + "static/media/Logo.31bbb45d.webp";